import type { User } from '@entities/user';
import { BUS_IFRAME_ELM_ID } from '@main/config/bus.config';
import { BusAuthentication } from '@main/bus-layer/bus-authentication';
import type {
  UserSSOLoginAuthenticator,
  UserSSOLoginRequest,
} from '../usecases/user-sso-login.usecase';

export class BusUserSSOLoginAuthenticator implements UserSSOLoginAuthenticator {
  private static Ins: BusUserSSOLoginAuthenticator;

  constructor() {
    return (
      BusUserSSOLoginAuthenticator.Ins ??
      (BusUserSSOLoginAuthenticator.Ins = this)
    );
  }

  async authenticate({
    code,
    redirectUrl,
  }: UserSSOLoginRequest): Promise<User> {
    const target: HTMLIFrameElement = <HTMLIFrameElement>(
      document.getElementById(BUS_IFRAME_ELM_ID)
    );

    const {
      company,
      currentUser: info,
      credentials,
    } = await BusAuthentication.loginBySso(target, code, redirectUrl);

    return {
      company,
      credentials,
      info,
    };
  }
}
